import {MessageErrorDetails} from '../../messages/entities/message-error-details.model';

export class FileValidationError extends Error {
  private readonly _details: MessageErrorDetails;

  constructor(m: string, d: MessageErrorDetails) {
    super(m);
    this._details = d;
  }

  public get details() {
    return this._details;
  }
}
